/**
 * if seed is used, uuid will be the same if same seed is used again
 *
 * @packageDocumentation
 * @module text/uuid
 * @preferred
 */
import v4 from "uuid/v4.js";
export const uuid = (seed) => {
    if (!seed) {
        return v4();
    }
    return v4({
        random: Buffer.from(seed.padEnd(16, "."), "utf8"),
    });
};
